/*global require*/
// this defines angular so we can load it sooner
define('angular', [], function(){
    return angular;
});

// Configuration for `require.js`.
require.config({
    baseUrl: typeof dna !== 'undefined' ? dna.app.resourcesUrl + '/' : './',
    // These are simply aliases for the given paths. Now in our app we can use
    // the aliases instead of typing the whole path.
    paths: {
        // use ['cdn path', 'local path'] which will first try the cdn path and then fallback to the local path if the cdn is down
        // see: http://tech.pro/blog/1639/using-rjs-to-optimize-your-requirejs-project

        //libs
        'FileSaver':            '../assets/js/libs/FileSaver',
        'RouteMap':             '../assets/js/libs/route-map-1.0.0',
        'MapboxGL':             ['https://api.tiles.mapbox.com/mapbox-gl-js/v0.43.0/mapbox-gl','../assets/js/libs/mapbox-gl.0.43.0'],
        'clamp':                '../assets/js/libs/clamp.0.5.1',

        // plugins
        'ngRoute':              '../assets/js/plugins/angular-route-1.4.7',
        'ngSanitize':           '../assets/js/plugins/angular-sanitize-1.4.7',
        'angularLazyImg':       '../assets/js/plugins/angular-lazy-load',
        'text':                 '../assets/js/plugins/text-2.0.6',
        'ngCache':              '../assets/js/plugins/angular-cache-4.3.2',
        'ngUpload':             '../assets/js/plugins/ng-upload-0.5.14-acom-dna',
        'angularI18n':          typeof dna !== 'undefined' && dna.app.siteLocale && dna.app.siteLocale.length > 0 ? 'https://www.ancestrycdn.com/dna/static/js/angular/i18n/1.4.7/angular-locale_' + dna.app.siteLocale.toLowerCase() : 'https://www.ancestrycdn.com/dna/static/js/angular/i18n/1.4.7/angular-locale_en',
        'ngAnimate':            '../assets/js/plugins/angular-animate-1.4.7',
        'ngSVGAttributes':      '../assets/js/plugins/svgDirs',
        'fileSaver':            '../assets/js/plugins/filesaver',
        // if facebook fails (FF Incognito), load an empty file - With a fallback require handles the bad response from FF correctly
        // Code already disables FB share if FB SDK wasn't loaded correctly
        'facebookApi':          ['https://connect.facebook.net/en_US/sdk', '../assets/js/downFiles/empty']
    },
    // Wraps non-AMD modules in the "define" boilerplate  https://cdnjs.cloudflare.com/ajax/libs/angular.js/1.4.7/i18n/angular-locale_aa-dj.js
    shim: {
        'ngRoute' :             {'deps':    ['angular']},
        'ngSanitize' :          {'deps':    ['angular']},
        'ngCache':              {'deps':    ['angular']},
        'ngUpload':             {'deps':    ['angular']},
        'angularI18n':          {'deps':    ['angular']},
        'angularLazyImg':       {'deps':    ['angular']},
        'ngAnimate':            {'deps':    ['angular']}
    },
    priority: [],
    config: {
        text: {
            useXhr: function (url, protocol, hostname, port) {
                return hostname === 'www.ancestrycdn.com' || window.location.hostname === hostname;
            }
        }
    },
    map: {
        '*': {
            'node': 'require-node-module.js'
        }
    },
});

define("require.config.js", function(){});

